import * as type from "../../types/API/emailCredentialType";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const createEMailCredentialReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.CREATE_EMAIL_CREDENTIAL:
      return {
        ...state,
        loading: true,
      };
    case type.CREATE_EMAIL_CREDENTIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData.message,
      };
    case type.CREATE_EMAIL_CREDENTIAL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getEMailCredentialReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_EMAIL_CREDENTIAL:
      return {
        ...state,
        loading: true,
      };
    case type.GET_EMAIL_CREDENTIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData.data,
      };
    case type.GET_EMAIL_CREDENTIAL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateEMailCredentialReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_EMAIL_CREDENTIAL:
      return {
        ...state,
        loading: true,
      };
    case type.UPDATE_EMAIL_CREDENTIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData.message,
      };
    case type.UPDATE_EMAIL_CREDENTIAL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteEMailCredentialReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_EMAIL_CREDENTIAL:
      return {
        ...state,
        loading: true,
      };
    case type.DELETE_EMAIL_CREDENTIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData.message,
      };
    case type.DELETE_EMAIL_CREDENTIAL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
